import '../assests/CSS/visual.css';
import bg_img from '../assests/images/visualbreak_img.svg';
import bg_img_mob from '../assests/images/visualbreak_bg_mobile.svg';

const VisualBreak = () => {

  const handleSubmit = () => {
    const formSection = document.getElementById('inquiry-form'); 
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className='visual-break'>
      <div className='visual-left'>
        <div >
          <img  id='visual-bg' src={bg_img} alt="Visual Background" />
          <img  id='visual-bg_mob' src={bg_img_mob} alt="Visual Background" />
        <div className="hexagonal-img"> </div>     
      </div>
        
      </div>
      <div className="visual-right">
        <div className="visual-right-content">
          <h1>The New Era of Global B2B Sourcing</h1>
          <p>Beyond the Basic Directory: The Challenge of Finding the Right Fit</p>
          <button onClick={handleSubmit}>Submit Request</button>
        </div>
      </div>
    </section>
  );
};

export default VisualBreak;
